import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9vepscyv: FaireBrandEntity = {
  token: "b_9vepscyv",
  type: "brand",
  name: "The Neighborgoods",
  avatarUrl:
    "https://cdn.faire.com/fastly/e5a7b5306430d7e3328298fa8388474d830240fe5bf4a7bd0f4846fbaaf0b1cd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ca40cf8a4072129a5816e1f1fe1719d12390bd1a4bdd8cf05a4c95e96677723b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e5a7b5306430d7e3328298fa8388474d830240fe5bf4a7bd0f4846fbaaf0b1cd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ca40cf8a4072129a5816e1f1fe1719d12390bd1a4bdd8cf05a4c95e96677723b.jpeg",
  location: "DC, WA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 113,
  isTopShop: true,
  isInsider: true,
  description:
    "The Neighborgoods is a one stop shop to pick up witty and unique gifts for any and all occasions. We create a variety of colorful food-themed goods such as our signature dish towels, swedish dishcloths, tote bags, aprons, greeting cards, pins, and more. Our fun-loving goods are sure to bring a smile to anyone’s face.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.828Z",
    importedBy: "entity-db-cli",
  },
};
